import React, { FC, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Bell from "../../../assets/Icons/Bell.svg";
import Notification from "../../../assets/Icons/Notification.svg";
import Pipe from "../../../assets/Icons/Pipe.svg";
import { UserMenuNavbarProps } from "./types";
import { UserMenu } from "./UserMenu";
import { Menu } from "@mui/material";
import "./UserMenuNavbarStyle.css";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "store/types";
import { CalculationHistoryProps } from "store/replenishment/types";
import NotificationItem from "components/Notification/NotificationItem";
import { closeNavigation } from "store/auth/auth.slice";

export const UserMenuNavbar: React.FC<UserMenuNavbarProps> = ({ user }) => {
  const dispatch = useDispatch();
  const calculationHistory = useSelector(
    (state: AppState) => state.replenishment.calculationHistory
  );

  const notificationToggle = useSelector(
    (state: AppState) => state.auth.notificationToggle
  );

  const [anchorEl] = React.useState<null | HTMLElement>(null);
  const [userMenu, setUserMenu] = React.useState<boolean>(false);
  const [notification, setNotification] = React.useState<boolean>(false);

  const handleClick = () => {
    setUserMenu(true);
  };
  const handleClose = () => {
    setUserMenu(false);
  };

  const handleNotification = () => {
    setNotification(!notification);
  };

  useEffect(() => {
    if (notificationToggle) setNotification(notificationToggle);
  }, [notificationToggle]);

  useEffect(() => {
    if (!notification) dispatch(closeNavigation());
  }, [notification]);

  const newName = user?.user?.name
    ? user?.user?.name
    : user?.user?.email
        ?.substring(0, user?.user?.email.lastIndexOf("@"))
        ?.replace(/([A-Z]+)/g, " $1")
        .replace(/([A-Z][a-z])/g, " $1");

  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          cursor: "pointer",
          margin: "7px",
          padding: "8px",
          borderRadius: "8px",
          display: "flex",
          background: notification ? "rgba(220, 227, 235, 0.3);" : "none",
        }}
        onClick={handleNotification}
      >
        <Box sx={{ marginTop: "5px" }}>
          <img src={Bell} alt="bell" />
        </Box>

        {notification && (
          <Box>
            <Box sx={{ margin: "0px 0px 0px 0px" }}>
              <img src={Notification} alt="bell" />
            </Box>
            <div
              style={{
                width: "336px",
                height: "322px",
                backgroundColor: "#FFFFFF",
                overflow: "hidden",
                border: "0.4px solid #DBDBDB",
                borderRadius: "4px",
                marginTop: "5px",
                position: "absolute",
                top: "54px",
                right: "220px",
                boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.25)",
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontFamily: "Lato",
                  padding: "8px 12px",
                }}
              >
                <p
                  style={{
                    fontSize: "16px",
                    color: "rgba(0, 0, 0, 0.6)",
                  }}
                >
                  Notifications
                </p>
                <p style={{ fontSize: "10px", color: "#0D47A1" }}>
                  Mark all as read
                </p>
              </div>
              <Box
                sx={{
                  maxHeight: "250px",
                  overflowY: "scroll",
                }}
              >
                {calculationHistory.length &&
                  calculationHistory.map(
                    (item: CalculationHistoryProps, index: number) => (
                      <NotificationItem
                        key={item.id}
                        item={item}
                        color={
                          index === 0 ? "rgba(25, 118, 210, 0.12)" : "white"
                        }
                      />
                    )
                  )}
              </Box>
            </div>
          </Box>
        )}
      </Box>
      <Box sx={{ margin: "12px 10px 0px 7px" }}>
        <img src={Pipe} height="80%" />
      </Box>

      <Box
        sx={{
          cursor: "pointer",
          marginLeft: "10px",
          marginTop: "7px",
          display: "flex",
          alignItems: "center",
          height: "50px",
        }}
        onClick={handleClick}
      >
        <Box
          sx={{
            height: "32px",
            width: "32px",
            borderRadius: "16px",
            background: "#E0E0E0",
          }}
        >
          <Typography
            sx={{
              height: "19px",
              width: "18px",
              fontFamily: "Lato",
              weight: 400,
              fontSize: "18px",
              lineHeight: "19.07px",
              textAlign: "center",
              margin: "6px 0px 0px 7px",
              color: "black",
            }}
          >
            {user?.user?.email?.substring(0, 1)}
          </Typography>
        </Box>
        <Box sx={{ margin: "7px 10px 0px 20px" }}>
          <img src={Pipe} height="42px" />
        </Box>
        <Box
          sx={{
            marginLeft: "3px",
            display: "flex",
            flexDirection: "column",
            alignItems: "end",
            // border: "1px solid black",
          }}
        >
          <Typography
            sx={{
              height: "19px",
              // width: "113px",
              fontFamily: "Lato",
              weight: 400,
              fontSize: "16px",
              lineHeight: "18.07px",
              color: "#FFFFFF",
              letterSpacing: "-0.02em",
              textTransform: "none",
            }}
          >
            {newName}
          </Typography>
          <Box
            sx={{
              height: "16px",
              alignItems: "right",
            }}
          >
            <Box
              sx={{
                maxWidth: "80ch",
                display: "flex",
                width: "max-content",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Lato",
                  weight: 400,
                  fontSize: "12px",
                  lineHeight: "15.07px",
                  textAlign: "right",
                  color: "#E0E0E0",
                  textTransform: "none",
                }}
              >
                {user.user.role.name
                  .replace(/([A-Z]+)/g, "  $1")
                  .replace(/([A-Z][a-z])/g, "  $1")}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Box>
      <Menu
        keepMounted
        //onClose={handleClose}
        open={userMenu}
        anchorEl={anchorEl}
        //open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          elevation: 0,
          sx: {
            overflow: "visible",
            filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
            mt: 1.5,
            "& .MuiAvatar-root": {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            "&:before": {
              content: '""',
              display: "block",
              position: "absolute",
              top: 20,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: "background.paper",
              transform: "translateY(-50%) rotate(45deg)",
              zIndex: 0,
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
      >
        <UserMenu
          name={newName}
          role={user?.user?.role?.name}
          sessionLogin="5/24 19:24"
        />
      </Menu>
    </Box>
  );
};
